/*
  The message to show for a failed request.

  Sagas used to show a fixed "Something Went Wrong!", so the server's reasons
  ("Overlaps the roster ...", "Cafeteria is in use ...", "Cutoff lunch is sold
  out") never reached the user. A 4xx message is shown as sent. A 5xx message is
  shown only when it reads like a business rule; database and network errors keep
  the generic text so internals are not put on screen.
*/
const TECHNICAL = /sql|validation failed|conversion failed|invalid column|invalid object|cannot read|undefined|null|econn|etimedout|timeout|request failed|connection|syntax|stack|tedious|procedure|parameter/i;

export const errorMessage = (e, fallback = 'Something Went Wrong!') => {
    const res = e && e.response;
    if (!res) return fallback;

    const data = res.data;
    const text = typeof data === 'string' ? data : (data && typeof data.message === 'string' ? data.message : '');
    if (!text || text.length > 300 || /^\s*</.test(text)) return fallback;

    if (res.status >= 400 && res.status < 500) return text;
    return TECHNICAL.test(text) ? fallback : text;
};

export default errorMessage;
